
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Drawer, List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse, Avatar, Typography, Grid } from '@mui/material';
import { DrawerHeader } from '../../theme';
import { iconos } from '../../data';
import { ModalCarrito } from './ModalCarrito';
import { useAuthStore } from '../../stores/usuarios/auth.store';
import { useGlobalValueStore, useUsuariosStore } from '../../stores';




const baseUrl = process.env.REACT_APP_API_URL;
const drawer = process.env.REACT_APP_DRAWER;
const drawerWidth = +drawer;





export const SlideShowMenu = () => {


    const navigate = useNavigate();
    const { usuario, menuData } = useAuthStore();
    const { cambioRolVenta } = useGlobalValueStore();    
    const { activarUserVenta } = useUsuariosStore();
    const { isSidebarOpen } = useSelector( state => state.iva );

    const [subMenu, setsubMenu] = useState(null);
    const [rutas, setRutas] = useState(null);



    const handleClick = (valor) => {
        const { titulo, ruta } = valor;
        setsubMenu(subMenu === titulo ? null : titulo);
        if( ruta ){
          navigate(`${ruta}`)
        }
    };


    const handleSubMenu = (menuopcion) => {
      setRutas( menuopcion );
      navigate(`${menuopcion}`);
    }



    const handleCahngeRolVenta = (view) => {
      if(view) {
        cambioRolVenta(view);
        activarUserVenta(null);
        // localStorage.setItem('view', view);
        // localStorage.removeItem('cliente');
      }
    }



    return (

      <Drawer sx={{width:drawerWidth, flexShrink:0, height:'100vh', '& .MuiDrawer-paper':{width:drawerWidth, height:'100vh'} }} variant="persistent" anchor="left" open={isSidebarOpen}>

          <DrawerHeader sx={{width:'100%', minHeight:'300px', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', textAlign:'center', marginBottom:'1rem'}}>
                <Grid item sx={{ mt:3, mb:2 }}>
                  {( usuario.img )
                  ? <Avatar src={`${ baseUrl }/uploads/usuarios/${ usuario.img }`} sx={{ width:'130px', height:'130px' }} />
                  : <Avatar src={`${ baseUrl }/uploads/usuarios/no-img.jpg`} sx={{ width:'130px', height:'130px' }} />
                  }
                </Grid>

                <Grid item sx={{ mb:3 }}>
                    <Typography variant='h4'>{ usuario.nombre }</Typography>
                    <Typography variant='h5' sx={{fontSize:13}}>{ usuario.role }</Typography>
                </Grid>
          </DrawerHeader>
          <Divider />
          
          <List sx={{overflowX:'auto', flex: 1, pb:3, pt:2}}>
            {menuData.map( (item) => (
              <div key={ item.titulo }>
                <ListItem disablePadding >
                  <ListItemButton onClick={() => handleClick(item)}>
                    <ListItemIcon>
                      { iconos[`${item.icono}`] 
                      ? React.cloneElement(iconos[`${item.icono}`], { style:{ color:'white'}})
                      : React.cloneElement(iconos['settings'], { style:{ color:'white'}})
                    }
                      
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="h3" sx={{ml:-2, fontSize:'16px'}}>{item.titulo}</Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>

                {(item.submenu) &&
                <Collapse in={subMenu === item.titulo} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.submenu.map( (sub) => (
                      <ListItemButton key={sub.titulo} sx={{pl:2}} onClick={ () => { 
                          handleSubMenu(sub.url);
                          handleCahngeRolVenta(sub.view);
                      }}>
                        <ListItemIcon> </ListItemIcon>
                        <ListItemText sx={{ml:-3, color:(rutas === sub.ruta) ? 'red' : ''}} 
                          primary={<Typography variant="h6" sx={{fontSize:'15px'}}>{sub.titulo}</Typography>} 
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
                }

              </div>
            ))}
          </List>

          <ModalCarrito />
          
        </Drawer>
    );
}